import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Clapperboard, Play, Info } from "lucide-react";
import api from "@/lib/api";
import { SectionHeader, DLLoading, EmptyState, Slogan } from "@/components/dl/ui";

export default function DLFilmRoom() {
  const { caseId } = useOutletContext();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get(`/dl/cases/${caseId}/film-room`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [caseId]);

  return (
    <div className="space-y-6">
      <SectionHeader kicker="The Film Room" title="Watch the film."
        desc="Commissioner analysis and commentary to help you prepare — organized chronologically." />

      <div className="dl-panel rounded-md px-4 py-3 flex items-center gap-3 border-l-2 border-l-sky-400/60">
        <Info className="w-5 h-5 text-sky-300 shrink-0" />
        <p className="text-xs text-white/60">
          <span className="font-semibold text-sky-300">Film Room is commentary, not evidence.</span> Only material in the <span className="text-gold">Case Record</span> counts in the game.
        </p>
      </div>

      {items === null ? <DLLoading label="Rolling the tape…" /> :
        items.length === 0 ? (
          <EmptyState icon={Clapperboard} title="No film posted yet" desc="The Commissioner hasn't added any analysis to the Film Room for this Case." testid="dl-film-empty" />
        ) : (
          <div className="space-y-4">
            {items.map((it, i) => (
              <div key={it.item_id} className="dl-panel rounded-lg overflow-hidden" data-testid="dl-film-row">
                <div className="flex flex-col md:flex-row">
                  {it.youtube_id ? (
                    <div className="md:w-80 shrink-0 aspect-video bg-black">
                      <iframe title={it.title} className="w-full h-full" src={`https://www.youtube.com/embed/${it.youtube_id}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                    </div>
                  ) : (
                    <div className="md:w-80 shrink-0 aspect-video bg-black/60 flex items-center justify-center"><Play className="w-8 h-8 text-white/30" /></div>
                  )}
                  <div className="p-4 flex-1">
                    <div className="text-[10px] font-mono text-white/35 uppercase tracking-wider">Film #{i + 1}</div>
                    <div className="font-display font-semibold text-white text-lg mt-0.5">{it.title}</div>
                    {it.note && <p className="mt-2 text-sm text-white/55">{it.note}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      <Slogan className="block text-center text-white/25 pt-2">Study the record. Call your play.</Slogan>
    </div>
  );
}
